export default __webpack_public_path__ + "bedaf1670674e09ae01a80b13cbfc472.svg";